import { Product } from '../../../generated/generated-types';

/**
 * Applies calculation mutation `updatedFields` onto an in-memory product model.
 */
export function applyProductCalculationUpdatesToModel(
    model: Product,
    updatedFields: Record<string, unknown> | null | undefined,
): void {
    if (!updatedFields || typeof updatedFields !== 'object' || Array.isArray(updatedFields)) {
        return;
    }

    for (const [key, value] of Object.entries(updatedFields)) {
        if (key === 'customFields') {
            continue;
        }
        (model as unknown as Record<string, unknown>)[key] = value;
    }

    const customFields = updatedFields.customFields;
    if (customFields != null && typeof customFields === 'object' && !Array.isArray(customFields)) {
        model.customFields = {
            ...(model.customFields ?? {}),
            ...(customFields as Record<string, unknown>),
        };
    }
}
